import React from "react";

const TodoSkeleton = () => {
  function numGenerate() {
    let newNum = Math.round(Math.random() * 60);
    if (newNum > 20 && newNum < 50) return newNum;
    else numGenerate();
  }
  let widthNum = 80 - numGenerate() || 50;
  
  return (
    <div className="flex justify-start items-center p-2 bg-slate-200 space-x-4 animate-pulse py-[8.5px] mb-1">
      <div className={`flex-shrink-0 w-[${widthNum}%] bg-slate-300 py-2 rounded-sm`}></div>
      <div className="flex-1"></div>
      <div className="flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-slate-300 border-slate-300"></div>
      <div className="flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-slate-300 border-slate-300"></div>
      <div className="flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-slate-300 border-slate-300"></div>
      <div className="flex-shrink-0 h-4 w-4 rounded ml-auto bg-slate-300"></div>
      <div className="flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer bg-slate-300"></div>
    </div>
  );
};

export default TodoSkeleton;
